import { render, staticRenderFns } from "./device-active.vue?vue&type=template&id=68cecaec&scoped=true"
import script from "./device-active.vue?vue&type=script&lang=js"
export * from "./device-active.vue?vue&type=script&lang=js"
import style0 from "./device-active.vue?vue&type=style&index=0&id=68cecaec&lang=scss&scoped=true"
import style1 from "./device-active.vue?vue&type=style&index=1&id=68cecaec&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cecaec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68cecaec')) {
      api.createRecord('68cecaec', component.options)
    } else {
      api.reload('68cecaec', component.options)
    }
    module.hot.accept("./device-active.vue?vue&type=template&id=68cecaec&scoped=true", function () {
      api.rerender('68cecaec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-service/device-data/device-active.vue"
export default component.exports